import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Refund = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      <span className="sr-only-seo">human on rent refund policy, boyfriend on rent cancellation, girlfriend on rent refund</span>

      <Header />

      <main className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-light text-gray-900 mb-4">Refund Policy</h1>
          <p className="text-gray-500 mb-12">Last updated: January 2024</p>

          {/* Important Notice */}
          <div className="bg-red-50 border border-red-200 rounded-2xl p-6 mb-12">
            <div className="flex items-start gap-4">
              <AlertTriangle className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-red-900 mb-2">Important: Membership Non-Refundable</h3>
                <p className="text-red-800">
                  All membership fees (₹294 / ₹589 / ₹1179) are <strong>NON-REFUNDABLE under any circumstances</strong>. 
                  Please carefully review our plans and features before purchasing a membership.
                </p>
              </div>
            </div>
          </div>

          <div className="legal-content">
            <h2>1. Membership Fees</h2>
            <p><strong>Membership fees are strictly non-refundable.</strong> This includes:</p>
            <ul>
              <li>6-Month Plan: ₹249 + 18% GST = ₹294</li>
              <li>5-Year Plan: ₹499 + 18% GST = ₹589</li>
              <li>Lifetime Plan: ₹999 + 18% GST = ₹1179</li>
            </ul>
            <p>Refunds will not be provided for:</p>
            <ul>
              <li>Change of mind after purchase</li>
              <li>Account suspension due to policy violations</li>
              <li>Inability to find bookings</li>
              <li>Technical issues on user's end</li>
              <li>Any other reason whatsoever</li>
            </ul>

            <h2>2. Service Access Fees (For Hirers)</h2>
            <p>The ₹99 service category access fee is generally non-refundable. However, refunds may be considered if:</p>
            <ul>
              <li>No providers are available in your area within 7 days of payment</li>
              <li>Technical error prevented you from using the service</li>
            </ul>
            <p>To request a refund, contact support within 7 days of payment with proof of the issue.</p>

            <h2>3. Booking Payments</h2>
            <h3>Before Provider Acceptance:</h3>
            <ul>
              <li>Full refund available if you cancel before a provider accepts your request</li>
              <li>Refund processed within 5-7 business days to original payment method</li>
            </ul>

            <h3>After Provider Acceptance:</h3>
            <ul>
              <li>Cancellation more than 24 hours before: 80% refund</li>
              <li>Cancellation 12-24 hours before: 50% refund</li>
              <li>Cancellation less than 12 hours before: No refund</li>
              <li>No-show by hirer: No refund</li>
            </ul>

            <h3>Provider Cancellation:</h3>
            <ul>
              <li>If a provider cancels after accepting, you receive a full refund</li>
              <li>The provider may face penalties for cancellation</li>
              <li>Refund processed within 3-5 business days</li>
            </ul>

            <h2>4. Service Issues</h2>
            <p>Refunds or credits may be provided if:</p>
            <ul>
              <li>Provider does not show up for accepted booking</li>
              <li>Service was significantly different from what was promised</li>
              <li>Provider violated our Code of Conduct during the service</li>
            </ul>
            <p>Report issues within 24 hours of the scheduled service time with evidence/documentation.</p>

            <h2>5. Refund Process</h2>
            <p>To request a refund (where applicable):</p>
            <ul>
              <li>Email: refunds@humanonrent.com</li>
              <li>Include: Booking ID, payment details, reason for refund</li>
              <li>Attach relevant evidence if applicable</li>
            </ul>
            
            <p>Processing times:</p>
            <ul>
              <li>UPI/Wallets: 1-3 business days</li>
              <li>Credit/Debit Cards: 5-7 business days</li>
              <li>Net Banking: 5-10 business days</li>
            </ul>

            <h2>6. Disputes</h2>
            <p>For refund disputes:</p>
            <ul>
              <li>Contact our support team first</li>
              <li>Provide all relevant documentation</li>
              <li>Allow up to 7 days for investigation</li>
              <li>Our decision on disputes is final</li>
            </ul>

            <h2>7. Exceptions</h2>
            <p>Special circumstances where additional refunds may be considered:</p>
            <ul>
              <li>Platform-wide technical outages</li>
              <li>Natural disasters or emergencies</li>
              <li>Government-mandated restrictions</li>
            </ul>
            <p>These are evaluated on a case-by-case basis.</p>

            <h2>8. Provider Earnings</h2>
            <p>Provider earnings from completed bookings are not subject to refund requests from hirers. Any disputes are handled separately through our support system.</p>

            <h2>9. Contact for Refunds</h2>
            <p>For refund-related queries:</p>
            <ul>
              <li>Email: refunds@humanonrent.com</li>
              <li>Phone: +91 98765 43210 (Mon-Sat, 9 AM - 6 PM)</li>
              <li>Response time: Within 48 hours</li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Refund;
